import axios from 'axios';

export default {
  namespaced: true,
  state: {
    leads: [],
    leadsTotal: 0,
    leadsInProgress: false,
    leadsError: false,
    leadsErrorMessage: '',

    activeContactsTotal: 0,
    activeContactsIds: [],
    activeContactsInProgress: false,
    activeContactsError: false,
    activeContactsErrorMessage: "",

    contactsStatusTotal: 0,
    contactsStatusNames: [],
    contactsStatusCounts: [],
    contactsStatusInProgress: false,
    contactsStatusError: false,
    contactsStatusErrorMessage: "",

    newLeadsDates: [],
    newLeadsCounts: [],
    newLeadsInProgress: false,
    newLeadsError: false,
    newLeadsErrorMessage: "",

    totalEventsDates: [],
    totalEventsCounts: [],
    totalEventsInProgress: false,
    totalEventsError: false,
    totalEventsErrorMessage: "",
  },
  mutations: {
    leadsQualify(state, leads) {
      state.leads = leads;
    },
    leadsInProgress(state) {
      state.leadsInProgress = true;
      state.leadsError = false;
    },
    leadsSuccess(state, leads) {
      state.leads = leads.data || leads;
      state.leadsTotal = leads.total || leads.length;
      state.leadsError = false;
      state.leadsInProgress = false;
    },
    leadsError(state, error) {
      state.leadsError = true;
      state.leadsInProgress = false;
      state.leadsErrorMessage = error.message;
    },
    clearErrors(state) {
      state.leadsError = false;
      state.leadsErrorMessage = '';
    },
    clearInProgress(state) {
      state.leadsInProgress = false;
    },
    activeContactsInProgress(state) {
      state.activeContactsInProgress = true;
      state.activeContactsError = false;
      state.activeContactsErrorMessage = "";
    },
    activeContactsError(state, error) {
      state.activeContactsInProgress = false;
      state.activeContactsError = true;
      state.activeContactsErrorMessage = error;
    },
    activeContactsSuccess(state, data) {
      state.activeContactsError = false;
      state.activeContactsInProgress = false;
      state.activeContactsErrorMessage = "";
      state.activeContactsTotal = data.active_contacts;
      state.activeContactsIds = data.contacts_ids;
    },
    contactsStatusInProgress(state) {
      state.contactsStatusInProgress = true;
      state.contactsStatusError = false;
      state.contactsStatusErrorMessage = "";
    },
    contactsStatusError(state, error) {
      state.contactsStatusInProgress = false;
      state.contactsStatusError = true;
      state.contactsStatusErrorMessage = error;
    },
    contactsStatusSuccess(state, data) {
      state.contactsStatusError = false;
      state.contactsStatusInProgress = false;
      state.contactsStatusErrorMessage = "";
      state.contactsStatusTotal = data.total;
      state.contactsStatusNames = data.data.map(({ status }) => status.String);
      state.contactsStatusCounts = data.data.map(({ contacts }) => contacts);
    },
    newLeadsInProgress(state) {
      state.newLeadsInProgress = true;
      state.newLeadsError = false;
      state.newLeadsErrorMessage = "";
    },
    newLeadsError(state, error) {
      state.newLeadsInProgress = false;
      state.newLeadsError = true;
      state.newLeadsErrorMessage = error;
    },
    newLeadsSuccess(state, data) {
      state.newLeadsError = false;
      state.newLeadsInProgress = false;
      state.newLeadsErrorMessage = "";
      state.newLeadsDates = data.data.map(({ date }) => date);
      state.newLeadsCounts = data.data.map(({ leads }) => leads);
    },
    totalEventsInProgress(state) {
      state.totalEventsInProgress = true;
      state.totalEventsError = false;
      state.totalEventsErrorMessage = "";
    },
    totalEventsError(state, error) {
      state.totalEventsInProgress = false;
      state.totalEventsError = true;
      state.totalEventsErrorMessage = error;
    },
    totalEventsSuccess(state, data) {
      state.totalEventsError = false;
      state.totalEventsInProgress = false;
      state.totalEventsErrorMessage = "";
      state.totalEventsDates = data.data.map(({ date }) => date);
      state.totalEventsCounts = data.data.map(({ events }) => events);
    },
  },
  actions: {
    async getLeadsQualify({ commit, rootState }, querySettings) {
      const { sortBy, rowsPerPage, descending } = querySettings.pagination;
      const { selectedTypes, leadsource } = querySettings;
      commit('leadsInProgress');
      let response;
      const defaultOrder = '$sort[created_at] = 1';
      let params = sortBy ? `$sort[${sortBy}]=${(descending ? '-1' : '1')}` : defaultOrder;
      params += `&status=${String(selectedTypes)}`;
      if (leadsource !== '') {
        params += `&lead_source=${leadsource}`;
      }
      if (rowsPerPage) {
        params += `&$limit=${rowsPerPage}`;
      }
      try {
        response = await axios.get(`${process.env.VUE_APP_INTEGRATIONS}/qualify/reporting/dashboard?${params}`);
        if (response.data.data.error) {
          commit('leadsError', 'Error getting qualify widget data');
        }
      } catch (error) {
        commit('leadsError', error);
      }
      commit('leadsSuccess', response.data.data.leads);
    },
    clearErrors({ commit }) {
      commit('clearErrors');
    },
    async getActiveContactsQualify({ commit, rootState }, querySettings) {
      const { leadsource } = querySettings;
      commit('activeContactsInProgress');
      let response;
      const params = `lead_source=${String(leadsource)}`;
      try {
        response = await axios.get(`${process.env.VUE_APP_INTEGRATIONS}/qualify/reporting/dashboard/active-contacts?${params}`);
        if (response.data.error) {
          commit('activeContactsError', 'Error getting qualify active contacts data');
        }
      } catch (error) {
        commit('activeContactsError', error);
      }
      commit('activeContactsSuccess', response.data);
    },
    async getContactsStatusQualify({ commit, rootState }, querySettings) {
      const { leadsource } = querySettings;
      commit('contactsStatusInProgress');
      let response;
      const params = `lead_source=${String(leadsource)}`;
      try {
        response = await axios.get(`${process.env.VUE_APP_INTEGRATIONS}/qualify/reporting/dashboard/contacts-status?${params}`);
        if (response.data.error) {
          commit('contactsStatusError', 'Error getting qualify contacts status data');
        }
      } catch (error) {
        commit('contactsStatusError', error);
      }
      commit('contactsStatusSuccess', response.data);
    },
    async getNewLeadsQualify({ commit, rootState }, querySettings) {
      const { leadsource, startDate, endDate } = querySettings;
      commit('newLeadsInProgress');
      let response;
      const params = `lead_source=${String(leadsource)}&start_date=${startDate}&end_date=${endDate}`;
      try {
        response = await axios.get(`${process.env.VUE_APP_INTEGRATIONS}/qualify/reporting/dashboard/new-leads?${params}`);
        if (response.data.error) {
          commit('newLeadsError', 'Error getting qualify new leads data');
        }
      } catch (error) {
        commit('newLeadsError', error);
      }
      commit('newLeadsSuccess', response.data);
    },
    async getTotalEventsQualify({ commit, rootState }, querySettings) {
      const { leadsource, startDate, endDate } = querySettings;
      commit('totalEventsInProgress');
      let response;
      const params = `lead_source=${String(leadsource)}&start_date=${startDate}&end_date=${endDate}`;
      try {
        response = await axios.get(`${process.env.VUE_APP_INTEGRATIONS}/qualify/reporting/dashboard/total-events?${params}`);
        if (response.data.error) {
          commit('totalEventsError', 'Error getting qualify total events data');
        }
      } catch (error) {
        commit('totalEventsError', error);
      }
      commit('totalEventsSuccess', response.data);
    },
  },
  
};
